import React from "react";
import { NavLink, Outlet, useLocation, Navigate, Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const isAdmin = (role) => role === "super_admin" || role === "admin";

function SidebarAuth() {
  const { user, logout } = useAuth();
  if (!user) return null;
  return (
    <div className="proj-user">
      <span className="proj-user-email">{user.email}</span>
      <span className="proj-user-role">{user.role}</span>
      <button className="proj-link proj-link-danger" onClick={logout}>
        Sign out
      </button>
    </div>
  );
}

// Authenticated app shell (sidebar + routed content). Requires a session;
// nav items are shown based on role.
export default function AppLayout() {
  const { user, isAuthed, loading, has } = useAuth();
  const location = useLocation();

  if (loading) return <div className="proj-center proj-muted">Loading…</div>;
  if (!isAuthed) return <Navigate to="/login" state={{ from: location }} replace />;

  const admin = isAdmin(user.role);
  const canManageUsers = has("user.manage");
  const navClass = ({ isActive }) => (isActive ? "nav-item active" : "nav-item");

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <Link to="/" className="sidebar-logo" style={{ textDecoration: "none", color: "inherit" }}>
          <span className="logo-mark" />
          <span className="logo-text">AdIntel AI</span>
        </Link>
        <nav className="sidebar-nav">
          {admin && (
            <NavLink to="/dashboard" className={navClass}>
              <svg viewBox="0 0 20 20" fill="none"><rect x="2" y="2" width="7" height="7" rx="1.5" fill="currentColor" opacity=".9"/><rect x="11" y="2" width="7" height="7" rx="1.5" fill="currentColor" opacity=".4"/><rect x="2" y="11" width="7" height="7" rx="1.5" fill="currentColor" opacity=".4"/><rect x="11" y="11" width="7" height="7" rx="1.5" fill="currentColor" opacity=".4"/></svg>
              Dashboard
            </NavLink>
          )}
          <NavLink to="/projects" className={navClass}>
            <svg viewBox="0 0 20 20" fill="none"><path d="M3 6a2 2 0 0 1 2-2h3l2 2h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6z" stroke="currentColor" strokeWidth="1.6"/></svg>
            Projects
          </NavLink>
          {canManageUsers && (
            <NavLink to="/users" className={navClass}>
              <svg viewBox="0 0 20 20" fill="none"><circle cx="7" cy="6" r="3" stroke="currentColor" strokeWidth="1.6"/><path d="M2 17c0-2.8 2.2-5 5-5s5 2.2 5 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/><path d="M13 4.5a2.5 2.5 0 0 1 0 5M14.5 12.2c1.9.5 3.5 2.3 3.5 4.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>
              Users
            </NavLink>
          )}
          {admin && (
            <>
              <NavLink to="/campaigns" className={navClass}>
                <svg viewBox="0 0 20 20" fill="none"><path d="M3 5h14M3 10h14M3 15h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
                Campaigns
              </NavLink>
              <NavLink to="/insights" className={navClass}>
                <svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.8"/><path d="M10 7v3l2 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
                Claude AI
              </NavLink>
            </>
          )}
        </nav>
        <div className="sidebar-footer">
          <SidebarAuth />
          <div className="connection-status" style={{ marginTop: 14 }}>
            <span className="status-dot" />
            Backend connected
          </div>
        </div>
      </aside>

      <main className="page-content">
        <Outlet />
      </main>
    </div>
  );
}
